import { useRecoilState } from "recoil";
import { useUpdateUserPreferenceMutation } from "../../react-query/user/mutations";
import { preferenceState } from "../../recoil/preference/preferenceAtom";
import { PreferencesType } from "../../types/account/type";

export const usePreference = () => {
  const [preference, setPreference] = useRecoilState(preferenceState);
  const { mutate: updatePreferenceMutation } = useUpdateUserPreferenceMutation();

  type SelectedSpaceIdsKey = keyof Pick<PreferencesType, "selectedSpaceIds">;
  const SELECTED_SPACE_IDS_KEY: SelectedSpaceIdsKey = "selectedSpaceIds";

  const updatePreference = (partial: Partial<PreferencesType>) => {
    if (SELECTED_SPACE_IDS_KEY in partial) {
      const newSelectedSpaceIds = Array.from(new Set(partial.selectedSpaceIds));
      setPreference((prev) => ({
        ...prev,
        ...partial,
        selectedSpaceIds: newSelectedSpaceIds,
      }));
      updatePreferenceMutation({ ...partial, selectedSpaceIds: newSelectedSpaceIds });
      return;
    }

    setPreference((prev) => ({ ...prev, ...partial }));
    updatePreferenceMutation(partial);
  };

  return {
    preference,
    updatePreference,
  };
};
